export default __webpack_public_path__ + "static/media/photo5.ce3cae75.jpg";